// constants for the draggable item types
export default {
  DISK: 'disk',
}